<template>
    <ur-modal ref="aiccMsgBox" :title="title" v-model="isModalShow" dragable :size="modalSize" :full-screen="modalSize==='fullScreen'" @closed="modalClosed">
        <template><span v-html="message"></span></template>
        <template slot="action">
            <ur-button @click="onCancelClick" v-if="cancelButtonShow">{{cancelText}}</ur-button>
            <ur-button @click="onOkClick" main ref="okButton" class="btn btn_color primary btn_m">{{okText}}</ur-button>
        </template>
    </ur-modal>
</template>

<script>
/*
이 컴포넌트는 src\common\components\form\SuiMessageBox\SuiMessageBox.vue와
UI Dev 소스에서 demo\ur\page\guide\components\modal\sample\urModalB1C3_modal.vue 파일을 참고하여 만들었다.
utils에 aiccMessageBox()를 등록하는 곳은 src\apps\portal\App.vue와 src\apps\popup\App.vue 안에 있다.
popup 디렉토리 아래 App.vue에도 넣는 이유는 window.open()으로 새로 뜨는 창에서는 이 함수를 쓰게끔 하기 위함이다.

사용법은 
utils.aiccMessageBox('제목', '보여줄 문장.<br><b>html을 써도 된다.</b>', 'OK 버튼 글씨', OK 버튼 눌렸을 때 처리할 함수, 'Cancel 버튼 글씨', Cancel 버튼 눌렸을 때 처리할 함수, 'urModal에 정의된 크기');
urModal에 정의된 크기는 small, medium, large, xlarge, xxlarge, fullScreen 중 하나. 지정하지 않으면 기본값인 midium이 적용됨.
Cancel 이하를 지정하지 않으면 확인 버튼 하나만 나온다.

예시
utils.aiccMessageBox('제목', '<b>고객 만족도 조사 2021</b> 캠페인을 삭제 하시겠습니까?<br>* 삭제하신 캠페인은 되돌릴 수 없습니다.', '삭제하기', this.onOkClick);
utils.aiccMessageBox('제목', '<b>고객 만족도 조사 2021</b> 캠페인을 삭제 하시겠습니까?<br>* 삭제하신 캠페인은 되돌릴 수 없습니다.', '삭제하기', this.onOkClick, '취소', this.onCancelClick, 'small');
utils.aiccMessageBox('제목', '<b>고객 만족도 조사 2021</b> 캠페인을 삭제 하시겠습니까?<br>* 삭제하신 캠페인은 되돌릴 수 없습니다.', '삭제하기', this.onOkClick, '취소', this.onCancelClick);
*/

export default {
    name: 'AiccMessageBox',
    props:{
        selfDestroy: {
            type: Boolean,
            default: false
        }
    },
    data() { return {
        isModalShow: false,
        title: 'Title',
        message: '',
        okText: 'Ok',
        okHandler: null,
        cancelText: 'Cancel',
        cancelHandler: null,
        modalSize: 'small',
        cancelButtonShow: false
    }},
    computed:{
        modal() {
            return this.$refs.aiccMsgBox;
        }
    },
    watch: {
        // 작동하는 것 같지 않아서 주석 처리
        // isModalShow() {
        //     if (this.selfDestroy && !this.isModalShow) {
        //         this.$destroy();
        //     }
        // }
    },
    beforeDestroy() {
        // 작동하는 것 같지 않아서 주석 처리
        // this.$root.$el.parentNode.removeChild(this.$root.$el);
    },
    methods:{
        show(title, message, okText, okHandler, cancelText, cancelHandler, modalSize) {
            this.title = title;
            this.message = message.replace(/(?:\r\n|\r|\n)/g, '<br />');
            this.okText = okText;
            this.okHandler = okHandler;
            this.cancelText = cancelText;
            this.cancelHandler = cancelHandler;
            
            this.isModalShow = true;

            if(modalSize) {
                this.modalSize = modalSize;
            }

            if(cancelText && cancelText.length > 0) {
                this.cancelButtonShow = true;
            } else {
                this.cancelButtonShow = false;
            }

            this.modal.open();
        },
        isActivated() {
            return this.isModalShow;
        },
        modalClosed(value){
            // console.log("modalClosed", value);
            
            if(value !== undefined) {
                // 오른쪽 위 [X]를 누르면 value에 click 이벤트가 넘어 온다. ok 버튼이나 cancel 버튼을 눌렀을 때는 undefined가 넘어온다.
                // cancel 버튼을 누른 것처럼 처리하자.
                if(this.cancelHandler) {
                    this.cancelHandler();
                }
            }
        },
        onCancelClick() {
            if(this.cancelHandler) {
                this.cancelHandler();
            }

            this.isModalShow = false;
            this.modal.close();
        },
        onOkClick() {
            if(this.okHandler) {
                this.okHandler();
            }

            this.isModalShow = false;
            this.modal.close();
        }
    }
}
</script>

<style scoped>

</style>

